import { render, staticRenderFns } from "./BatchClientsList.vue?vue&type=template&id=515d4116&scoped=true"
import script from "./BatchClientsList.vue?vue&type=script&lang=js"
export * from "./BatchClientsList.vue?vue&type=script&lang=js"
import style0 from "./BatchClientsList.vue?vue&type=style&index=0&id=515d4116&prod&scoped=true&lang=css"
import style1 from "./BatchClientsList.vue?vue&type=style&index=1&id=515d4116&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d4116",
  null
  
)

export default component.exports